import Vue from "vue";
import Vuex from "vuex";
import Router from "vue-router";
import { flatten, flattenCategory, fillCategories, fillItems } from "./helpers";

Vue.use(Router);
Vue.use(Vuex);
var router = new Router();

const state = {
  access_token: "",
  authenticated: false,
  basket: null,
  basketPartial: null,
  basketSelected: 0,
  basketSize: 0,
  bpl: null,
  bpl_current: {
    BrandId: 0,
    CompanyId: 0,
    LanguageId: 0,
    DealerId: 0
  },
  currentUser: [],
  documents: null,
  filesaver: {
    props: {Id: 10816},
    url: "http://ricoh-chameleon-api.vintage.eu/api/v1/Documents/Download"
  },
  filteredImages: null,
  filteredImagesLoading: false,
  filterParams: {
    minResolution: 72,
    pageSize: 9,
    pageNumber: 1,
    pageCategoryIds: "",
    categoryIds: "",
    productIds: "",
    subCategoryIds: ""
  },
  filters: {
    offering: [],
    categories: [],
    items: [],
    resolutions: []
  },
  hasArchives: true,
  header: {
    title: "",
    intro: ""
  },
  imageProcessing: false,
  images: null,
  isArchive: false,
  langLoaded: false,
  loadedUsers: [],
  loading: false,
  loadingBasket: 1,
  login_failure: "",
  mailSent: false,
  mailSending: false,
  menu: {},
  menuItem: -1,
  newsDetails: {},
  news: {},
  newsPage: 0,
  products: null,
  resources: [],
  scrolled: false,
  sidebarActive: false,
  searchTerms: [],
  searchResults: null,
  searchProductList: null,
  searchSelectedProduct: -1,
  searchStringCurrent: "",
  showOnlyProducts: false,
  selectedImages: [],
  showModal: false,
  showDisclaimer: false,
  userHash: "",
  currentCulture: "en-US"
};

const mutations = {
  MENU_ITEM_CHANGED (state, menuItem, sidebarActive) {
    state.menuItem = (menuItem === state.menuItem) ? -1 : menuItem;
    state.sidebarActive = sidebarActive && state.menuItem > -1;
  },

  SCROLLED (state, scrolled) {
    state.scrolled = scrolled;
  },

  MENU_RECIEVED (state, menu) {
    state.menu = menu.Menu;
    state.menu.Language = menu.Languages;
    state.menu.portals = menu.PortalApplications;
    state.menu.LoggedUser = menu.LoggedUser;
    state.menu.AdminUrl = menu.AdminUrl;
    state.menu.ImpersonationVisible = menu.ImpersonationVisible;
    if (menu.LoggedUser.ShowDisclaimer) {
      state.showDisclaimer = true;
    }
  },

  NEWS_RECIEVED (state, news) {
    state.news = news;
  },

  NEWS_DETAILS_LOADED (state, news) {
    state.newsDetails = news;
  },

  CHANGE_NEWS_PAGE (state, shift) {
    state.newsPage += shift;
  },

  DOCUMENTS_LOADED (state, documents) {
    state.loading = false;

    if (documents.ProductsInCategory) {
      documents.ProductsInCategory = flattenCategory(documents.ProductsInCategory);
    }
    state.header.title = documents.PageTitle;
    state.header.intro = documents.PageIntro;

    state.documents = documents;
  },

  LOADING (state, hasArchives) {
    state.hasArchives = hasArchives;
    state.loading = true;
  },

  LOADING_ERROR (state) {
    state.loading = false;
  },

  LOADING_BASKET (state) {
    state.loadingBasket++;
  },

  PRODUCTS_LOADED (state, products) {
    state.loading = false;

    flatten(products.CategoryTree[0].Items);

    state.header.title = products.PageTitle;
    state.header.intro = products.PageIntro;
    state.products = products.CategoryTree;
  },

  IMAGES_LOADED (state, images) {
    state.loading = false;
    state.images = images;
  },

  FILTERS_LOADED (state, filters) {
    state.header.title = filters.PageTitle;
    state.header.intro = filters.PageIntro;
    state.loading = false;

    state.filters.resolutions = [];
    for (let i = 0; i < filters.AvailableResolutions.length; i++) {
      state.filters.resolutions.push({Id: filters.AvailableResolutions[i].Value, Name: filters.AvailableResolutions[i].Text});
    }

    var offering = filters.CategoryTree;
    for (let i = 0; i < offering.length; i++) {
      offering[i].checked = false;
      state.filters.offering.push(offering[i]);

      fillCategories(offering[i].Items, state.filters.categories, state.filters.items);
    }
  },

  BPL_LOADED (state, bpl) {
    state.bpl = bpl;

    if (!state.bpl_current.BrandId) {
      state.bpl_current.BrandId = window.localStorage.getItem("BrandId") || bpl.Brands[0].Value;
      if (bpl.Companies.length > 1) {
        state.bpl_current.CompanyId = window.localStorage.getItem("CompanyId") || 2;
      } else {
        state.bpl_current.CompanyId = bpl.Companies[0].Value;
      }
    }

    state.bpl_current.LanguageId = window.localStorage.getItem("LanguageId") || bpl.Languages[0].Value;
    state.bpl_current.DealerId = window.localStorage.getItem("DealerId") || 0;
  },

  BPL_COMPANY_CHANGED (state, bpl) {
    console.log("change bpl", bpl);
    state.bpl = bpl;
    state.bpl_current.LanguageId = bpl.Languages[0].Value;
    state.bpl_current.DealerId = bpl.Dealers[0].Value;
  },

  BPL_SET (state, bpl) {
    window.localStorage.setItem("BrandId", bpl.BrandId);
    window.localStorage.setItem("CompanyId", bpl.CompanyId);
    window.localStorage.setItem("LanguageId", bpl.LanguageId);
    window.localStorage.setItem("DealerId", bpl.DealerId);

    document.location.reload();
  },
  HOME_PAGE_LOADED (state) {
    state.loading = false;
  },
  SEARCH_STRING_SET (state, searchString) {
    state.searchProductList = null;
    state.searchStringCurrent = searchString;
  },

  SEARCH_TERMS_LOADED (state, searchTerms) {
    state.searchTerms = searchTerms;
  },

  SEARCH_RESULTS_LOADED (state, searchResults) {
    state.loading = false;
    state.hasAccess = true;
    state.searchResults = searchResults;
  },
  SEARCH_VALIDATION_LOADED (state, result) {
    state.loading = false;
    state.hasAccess = result.HasAccess;
    router.go("/search/" + window.fileTypeId + "/product/" + result.ItemId);
  },

  SEARCH_PRODUCTS_LOADED (state, searchProductList) {
    if (searchProductList.SearchString === state.searchStringCurrent) {
      state.header.title = searchProductList.PageTitle;
      state.header.intro = searchProductList.PageIntro;
      state.searchProductList = searchProductList.ItemList;
      state.showOnlyProducts = searchProductList.ShowOnlyProducts;
    }
  },

  LOGGED_IN (state, accessToken, userHash) {
    Vue.http.headers.common.Authorization = `Bearer ${accessToken}`;
    state.authenticated = true;
    state.access_token = accessToken;
    state.userHash = userHash;
    state.login_failure = "";

    window.localStorage.setItem("access_token", accessToken);
  },

  LOGGING_FAILURE (state, error) {
    state.login_failure = error.error_description;
  },

  LOGGING_FAILURE_RESET (state) {
    state.login_failure = "";
  },

  LOG_OUT (state, impersonation) {
    window.localStorage.setItem("BrandId", "");
    window.localStorage.setItem("CompanyId", "");
    window.localStorage.setItem("LanguageId", "");
    window.localStorage.setItem("DealerId", "");
    if (impersonation) {
      delete Vue.http.headers.common.Authorization;
      state.authenticated = false;
      state.access_token = "";
      window.localStorage.removeItem("OriginalBrandId");
      window.localStorage.removeItem("OriginalCompanyId");
      window.localStorage.removeItem("OriginalLanguageId");
      window.localStorage.removeItem("OriginalDealerId");
      window.localStorage.setItem("access_token", "");
    } else {
      if (window.localStorage.getItem("OriginalBrandId")) {
        window.localStorage.setItem("BrandId", window.localStorage.getItem("OriginalBrandId"));
        window.localStorage.setItem("CompanyId", window.localStorage.getItem("OriginalCompanyId"));
        window.localStorage.setItem("LanguageId", window.localStorage.getItem("OriginalLanguageId"));
        window.localStorage.setItem("DealerId", window.localStorage.getItem("OriginalDealerId"));
      } else {
        window.localStorage.removeItem("BrandId");
        window.localStorage.removeItem("CompanyId");
        window.localStorage.removeItem("LanguageId");
        window.localStorage.removeItem("DealerId");
      }
      document.location.reload();
    }
  },

  FILTERED_IMAGES_LOADED (state, filteredImages) {
    state.filteredImagesLoading = false;
    state.filteredImages = filteredImages;
  },

  FILTERED_IMAGES_LOADING (state) {
    state.filteredImagesLoading = true;
  },

  UPDATE_OFFERING_FILTER (state, filtered) {
    state.filters.categories = [];
    state.filters.items = [];

    state.filterParams.pageCategoryIds = filtered.join();
    state.filterParams.categoryIds = "";
    state.filterParams.productIds = "";

    for (var i = 0; i < state.filters.offering.length; i++) {
      if (filtered.length) {
        for (var l = 0; l < filtered.length; l++) {
          if (state.filters.offering[i].Id === filtered[l]) {
            fillCategories(state.filters.offering[i].Items, state.filters.categories, state.filters.items);
          }
        }
      } else {
        fillCategories(state.filters.offering[i].Items, state.filters.categories, state.filters.items);
      }
    }
  },
  LANGUAGE_LOADED (state, culture, resources) {
    state.currentCulture = culture;
    state.resources = resources;
    state.langLoaded = true;
    window.localStorage.setItem("current_culture", culture);
  },
  SET_CULTURE (state, culture) {
    state.currentCulture = culture;
  },

  UPDATE_CATEGORIES_FILTER (state, filtered) {
    state.filters.items = [];
    state.filterParams.categoryIds = filtered.join();
    state.filterParams.productIds = "";

    for (var i = 0; i < state.filters.categories.length; i++) {
      if (filtered.length) {
        for (var l = 0; l < filtered.length; l++) {
          if (state.filters.categories[i].Id === filtered[l]) {
            fillItems(state.filters.categories[i].Items, state.filters.items);
          }
        }
      } else {
        fillItems(state.filters.categories[i].Items, state.filters.items);
      }
    }
  },

  UPDATE_ITEMS_FILTER (state, filtered) {
    state.filterParams.productIds = filtered.join();
  },

  UPDATE_RESOLUTION_FILTER (state, resolutions) {
    state.filterParams.minResolution = resolutions[0] || 72;
  },

  BASKET_PARTIAL_LOADED (state, basketPartial) {
    state.loadingBasket--;
    state.basketPartial = basketPartial;
  },

  BASKET_LOADED (state, basket) {
    state.loading = false;
    state.basketSize = basket.Files.length;
    for (var i = 0; i < basket.Files.length; i++) {
      for (var j = 0; j < basket.Files[i].Items.length; j++) {
        basket.Files[i].Items[j].selected = false;
      }
    }
    state.basket = basket;
  },

  IMPERSONATION_MODAL_STATE (state, visibility) {
    state.impersonateModalVisibility = visibility;
  },

  USERS_LOADED (state, users) {
    var loadedUsers = [];
    while (users.length) {
      loadedUsers.push(users.splice(0, 4));
    }
    state.loadedUsers = loadedUsers;
  },

  USER_LOADED (state, user) {
    window.localStorage.setItem("BrandId", "");
    window.localStorage.setItem("CompanyId", "");
    window.localStorage.setItem("LanguageId", "");
    window.localStorage.setItem("DealerId", "");
    state.menu.LoggedUser.FullName = user.Name;
    state.menu.LoggedUser.Company = user.Company;
    state.showModal = false;
    if (user.CompanyId) {
      window.localStorage.setItem("CompanyId", user.CompanyId);
    }
    if (state.bpl_current.BrandId !== 0) {
      window.localStorage.setItem("OriginalBrandId", state.bpl_current.BrandId);
      window.localStorage.setItem("OriginalCompanyId", state.bpl_current.CompanyId);
      window.localStorage.setItem("OriginalLanguageId", state.bpl_current.LanguageId);
      window.localStorage.setItem("OriginalDealerId", state.bpl_current.DealerId);
    }
  },

  USER_BPL_LOADED (state, bpl) {
    state.bpl = bpl;

    state.bpl_current.BrandId = bpl.Brands[0].Value;
    state.bpl_current.LanguageId = bpl.Languages[0].Value;
    window.localStorage.setItem("BrandId", bpl.Brands[0].Value);
    window.localStorage.setItem("LanguageId", bpl.Languages[0].Value);
    if (bpl.Dealers.length > 2) {
      state.bpl_current.DealerId = 0;
      window.localStorage.setItem("DealerId", 0);
    } else {
      state.bpl_current.DealerId = bpl.Dealers[0].Value;
      window.localStorage.setItem("DealerId", bpl.Dealers[0].Value);
    }

    document.location.href = "/";
  },

  CLOSE_MODAL (state) {
    state.showModal = false;
  },

  SHOW_MODAL (state) {
    state.loadedUsers = null;
    state.showModal = true;
  },

  BASKET_SELECT_ALL (state) {
    state.basketSelected = 0;
    for (var i = 0; i < state.basket.Files.length; i++) {
      for (var j = 0; j < state.basket.Files[i].Items.length; j++) {
        state.basketSelected++;
        state.basket.Files[i].Items[j].selected = true;
      }
    }
  },

  BASKET_EMAIL_SELECTED (state) {
    console.log(state);
  },

  BASKET_DOWNLOAD_SELECTED (state) {
    console.log(state);
  },

  BASKET_DELETE_SELECTED (state) {
    console.log(state);
  },

  BASKET_ITEM_UPDATE (state, item, value) {
    state.basketSelected = value ? state.basketSelected + 1 : state.basketSelected - 1;
    for (var i = 0; i < state.basket.Files.length; i++) {
      var index = state.basket.Files[i].Items.indexOf(item);
      if (index > -1) {
        state.basket.Files[i].Items[index].selected = value;
      }
    }
  },

  DOWNLOAD (state, apiUrl, props) {
    state.filesaver.url = Vue.http.options.root + apiUrl;
    state.filesaver.props = Object.assign({}, props);
  },

  ARCHIVE_MODE_CHANGED (state, isArchive) {
    state.isArchive = isArchive;
  },

  MAIL_SENDING (state) {
    state.mailSending = true;
  },

  MAIL_SENT (state, item) {
    state.mailSending = false;
    state.mailSent = true;
  },

  MAIL_CONFIRMED (state) {
    state.mailSent = false;
  },

  SELECT_IMAGE (state, image) {
    const index = state.selectedImages.indexOf(image);
    if (index === -1) {
      state.selectedImages.push(image);
    }
  },

  DESELECT_IMAGE (state, image) {
    const index = state.selectedImages.indexOf(image);
    if (index > -1) {
      state.selectedImages.splice(index, 1);
    }
  },

  CLEAR_IMAGES_LIST (state) {
    state.imageProcessing = false;
    state.selectedImages = [];
  },

  START_IMAGE_PROCESSING (state) {
    state.imageProcessing = true;
  },

  DISCLAIMER_APPROVED (state) {
    state.menu.LoggedUser.ShowDisclaimer = false;
    state.showDisclaimer = false;
  }
};

export default new Vuex.Store({
  state,
  mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js